import { Divider, Modal, Row, Space } from "antd";

export function Footer() {
  return (
    <Row justify="center" align="middle">
      <Space align="center">
        <span style={{ fontSize: 10, paddingBottom: 12 }}>Copyright © 2021 Cancel™ LLC. My Rights Reserved</span>
        <Divider type="vertical" />
        <a
          onClick={() => {
            Modal.info({
              width: 480,
              title: "About Cancel™",
              content: (
                <>
                  <p>
                    Cancel™ was dreamed up by Scott Shapiro as a way to begin mending fences and reduce partisanship.
                  </p>
                  <p>
                    Voice by{" "}
                    <a href="https://twitter.com/LaraElinVO" rel="noreferrer" target="_blank">
                      Lara Elin.
                    </a>
                  </p>
                  <p>
                    Designed and implemented by{" "}
                    <a href="https://todays.pointless.click/about.html" rel="noreferrer" target="_blank">
                      Andrew Blakey.
                    </a>
                  </p>
                  <p>Cancel™ will IPO in late 2021.</p>
                  <p>To contact us, please create a new thread.</p>
                </>
              ),
            });
          }}
          style={{ fontSize: 10, paddingBottom: 12 }}
        >
          about
        </a>
      </Space>
    </Row>
  );
}
